// Latest blogs from https://medium.com/@kccreations1704 (fetched from profile)
// Add or update `url` when you have the direct article link for a post.

const blogs = [
  {
    id: 1,
    title:
      "When a Benchmark Number Is Just a Claim: Making AI Evaluations Cryptographically Verifiable",
    description:
      "Why benchmark leaderboards need cryptographic signatures and Merkle anchoring — and how to make eval results independently reproducible.",
    url: "https://medium.com/@kccreations1704/when-a-benchmark-number-is-just-a-claim-making-ai-evaluations-cryptographically-verifiable-b512503cff51",
    date: "Jun 11, 2025",
  },
  {
    id: 2,
    title: "What Happens When Your Voice Agent Fails at 2 a.m.?",
    description:
      "Reconstructing true end-to-end latency across ASR → LLM → TTS → transport, and building the observability layer that catches failures no single vendor can see.",
    url: "https://medium.com/@kccreations1704/what-happens-when-your-voice-agent-fails-at-2-a-m-e6ff504e94f3",
    date: "Jun 10, 2025",
  },
  {
    id: 3,
    title: "Vyper for AI Agent Workflows — Safe, Simple, Deterministic Agents",
    description:
      "I built three tiny Vyper contracts + a minimal Python agent to show how off-chain AI agents can interact with Ethereum safely.",
    url: "https://medium.com/@kccreations1704/vyper-for-ai-agent-workflows-safe-simple-deterministic-agents-1a89cd698dcf",
    date: "Dec 10, 2025",
  },
  {
    id: 4,
    title:
      "Pluralism, Pseudonymity, and the Future of ZK Identity: Why We Built Proof of Witness",
    description:
      "Over the past few years, I've been deeply involved in zero-knowledge (ZK) technology not just from the perspective of cryptography or…",
    url: "https://medium.com/@kccreations1704/pluralism-pseudonymity-and-the-future-of-zk-identity-why-we-built-proof-of-witness-2f8f57bc00cb",
    date: "Jul 1, 2025",
  },
  {
    id: 5,
    title: "We Cooked Storage. We Cooked Finance. Now We're Cooking Cloud.",
    description: "Why EigenCloud feels like the next evolution.",
    url: "https://medium.com/@kccreations1704",
    date: "Jun 24, 2025",
  },
  {
    id: 6,
    title:
      'The New Trust Paradigm: How Ethereum Made Me Rethink Everything About "Hardness"',
    description:
      "Let's Talk About Trust (And Why I Stopped Trusting the Old Way)",
    url: "https://medium.com/@kccreations1704",
    date: "Jun 5, 2025",
  },
  {
    id: 7,
    title:
      "DeAI is the New Crypto Frontier. Here's Why I'm Building a Movement Around It",
    description:
      "Okay, let's talk about something that's been living rent-free in my head lately: DeAI short for Decentralized Artificial Intelligence. If…",
    url: "https://medium.com/@kccreations1704",
    date: "May 27, 2025",
  },
  {
    id: 8,
    title:
      "Spinning Up EigenLayer AVSs using Othentic on Holešky: A Step-by-Step Guide for Devs",
    description: "Just cooked up a quick AVS using the Othentic stack.",
    url: "https://medium.com/@kccreations1704",
    date: "May 19, 2025",
  },
  {
    id: 9,
    title: "Ethereum x RISC-V: A Radical Rethink of Smart Contract Execution",
    description:
      "Ethereum's execution layer has come a long way, but it's no secret: the EVM is starting to show its age. In a recent post, Vitalik Buterin…",
    url: "https://medium.com/@kccreations1704",
    date: "Apr 23, 2025",
  },
  {
    id: 10,
    title:
      "A Deep Dive into Building Your Own Rollup: RollupKit Architecture Explained",
    description:
      "In recent years, rollups have become a popular approach to scaling blockchains. But building a rollup from scratch is no small feat —…",
    url: "https://medium.com/@kccreations1704",
    date: "Nov 13, 2024",
  },
  {
    id: 11,
    title:
      "Dare to Deploy: Building Your L3 Rollup Chain with Arbitrum and Avail Explained",
    description:
      "Hey there, intrepid blockchain builder! If you've ever dreamt of setting up your own Layer 3 (L3) rollup chain, it's time to roll up those sleeves…",
    url: "https://medium.com/@kccreations1704",
    date: "Nov 4, 2024",
  },
  {
    id: 12,
    title:
      "How Do Blockchains Ensure All Data Is Available Without Downloading Everything?",
    description:
      "Have you ever wondered how blockchains can scale up without forcing everyone to download every bit of data? How can we be sure that all the…",
    url: "https://medium.com/@kccreations1704/how-do-blockchains-ensure-all-data-is-available-without-downloading-everything-78b5b5b9e7a6",
    date: "Nov 1, 2024",
  },
];

export default blogs;
